// @todo: Refactor to constants when API will be ready
const itemRequirementsField = [
  {
    field: 'lineId',
    title: 'Line Id',
    hidden: true,
  },
  {
    field: 'partId',
    title: 'Part Id',
    hidden: true,
  },
  {
    title: 'Status',
    field: 'statusName',
  },
  {
    title: 'RfqNo',
    field: 'requirementNumber',
  },
  {
    title: 'Part Number',
    field: 'partNumber',
    width: 100,
  },
  {
    title: 'Customer PN',
    field: 'customerPN',
    width: 200,
  },
  {
    title: 'Description',
    field: 'description',
  },
  {
    title: 'Mfr',
    field: 'mfgName',
    width: 100,
  },
  {
    title: 'Qty',
    field: 'quantity',
    cell: 'formatSeparator',
    width: 100,
  },
  {
    title: 'Date Code',
    field: 'dateCode',
    width: 100,
  },
  {
    title: 'Buyer Target',
    field: 'buyerTargetPrice',
    cell: 'formatAmount',
    width: 100,
  },
  {
    title: 'Target Price',
    field: 'targetPrice',
    cell: 'formatAmount',
    width: 100,
  },
];

export default itemRequirementsField;